/**
 * Nomes dos cookies de sessão da loja, fonte única (proxy, ApiService, SessionService, sessão anônima, login de suporte
 * e ClearSale leem daqui).
 */

/** Token do cliente logado: é o que decide se há sessão (proxy e Authorization das chamadas). */
export const TOKEN_COOKIE = '@glofi:token'

/** Sessão anônima (header `GlofiSession`), aberta pelo `new-session`. */
export const ANON_TOKEN_COOKIE = '@glofi:AnonToken'

/** Marca do acesso do atendente (login-as-customer). */
export const SUPPORT_COOKIE = '@glofi:support'
